const FEATURES = ['qr_items', 'device', 'branch', 'subusers', 'language', 'cloud']

const PricingMixin = {
  props: {
    starredFeature: {
      type: String,
      default: '',
    },
  },
  methods: {
    getPackageBenefits(plan) {
      if (!plan) return []

      if (plan.is_custom) {
        return plan.features
      }
      const benefits = []
      FEATURES.forEach(featureKey => {
        const feature = plan.features.find(f => f.slug === featureKey)
        if (!feature) return

        const { limit } = feature
        // eslint-disable-next-line no-nested-ternary
        const choice = feature.limit === 0 ? 2 : (feature.limit > 1 ? 1 : 0)

        switch (feature.slug) {
          case 'qr_items': benefits.push({ text: this.$tc('features.feature-plans.qr_items', limit === 0 ? 2 : 1, [feature.limit]), slug: 'qr_items', starred: this.starredFeature === 'qr_items' }); break
          case 'device': benefits.push({ text: this.$tc('features.feature-plans.device', choice, [feature.limit]), slug: 'device', starred: this.starredFeature === 'device' }); break
          case 'branch': benefits.push({ text: this.$tc('features.feature-plans.branch', choice, [feature.limit]), slug: 'branch', starred: this.starredFeature === 'branch' }); break
          // eslint-disable-next-line no-nested-ternary
          case 'cloud': benefits.push({ text: this.$tc('features.feature-plans.cloud', limit === 0 ? 2 : (limit < 1024 ? 0 : 1), [feature.limit >= 1024 ? (feature.limit / 1024).toFixed(0) : feature.limit]), slug: 'cloud', starred: this.starredFeature === 'cloud' }); break
          case 'subusers': benefits.push({ text: this.$tc('features.feature-plans.subusers', choice, [feature.limit]), slug: 'subusers', starred: this.starredFeature === 'subusers' }); break
          case 'language': benefits.push({ text: this.$tc('features.feature-plans.language', limit > 1 || limit === 0 ? 2 : 1, [feature.limit]), slug: 'language', starred: this.starredFeature === 'language' }); break
          default: break
        }
      })
      return benefits
    },
  },
}

export default PricingMixin
